import {
  PublicationQueryPreferencesFragment,
  useGetPublicationsQuery,
} from '@sketch/gql-types'

interface GetCommunityPublicationsProps {
  preferences: Partial<PublicationQueryPreferencesFragment> | null
}

export const useGetCommunityPublications = ({
  preferences,
}: GetCommunityPublicationsProps) => {
  /**
   * Excluding the null values from the preferences so
   * BE doesn't throw errors
   */
  const variables = Object.fromEntries(
    Object.entries(preferences || {}).filter(([key, value]) => !!value)
  )

  const { sort, include, limit, search, exclude, documentType } = variables as {
    [K in keyof PublicationQueryPreferencesFragment]?: PublicationQueryPreferencesFragment[K]
  }

  return useGetPublicationsQuery({
    variables: {
      sort,
      include,
      limit,
      exclude,
      search: {
        name: search,
        documentType:
          documentType === 'ALL_DOCUMENT_TYPES' ? null : documentType,
      },
    },
  })
}
